
import React from 'react';
import { Skeleton } from '@/components/ui/skeleton';

const LoadingState = () => {
  // Create an array to render multiple card skeletons
  const skeletons = Array.from({ length: 8 }, (_, i) => i);

  return (
    <>
      {skeletons.map((index) => (
        <div key={index} className="flex flex-col animate-pulse">
          {/* Card image skeleton */}
          <Skeleton className="w-full aspect-square rounded-md mb-3" />
          
          {/* Name skeleton */}
          <Skeleton className="h-5 w-3/4 mb-2" />
          
          {/* Profession skeleton */}
          <Skeleton className="h-4 w-1/2 mb-2" />
          
          {/* Stats skeleton */}
          <div className="flex justify-between mt-1">
            <Skeleton className="h-3 w-1/4" />
            <Skeleton className="h-3 w-1/4" />
          </div>
        </div>
      ))}
    </>
  );
};

export default LoadingState;
